import React, { Component } from 'react'

import cm from './Placeholder.module.css'

export default class Placeholder extends Component {
  render() {
    return (
      <div className={cm.layout}>
        <div className={cm.caption}>Sorry, this flow is unavailable :(</div>
      </div>
    )
  }
}
